//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



/** Uitvoer van een lijst met gebruikersgroepen (incl. key). */
export interface GebruikersgroepenOutput {
    /** Lijst met gebruikersgroepen (incl. key) */
    gebruikersgroepen: { [key: string]: Gebruikersgroep; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een gebruikersgroep. */
export interface Gebruikersgroep {
    /** Naam van de Gebruikersgroep */
    naam: string;
    /** Beschrijving van de gebruikersgroep */
    beschrijving: string | null;
    /** ID van de organisatie */
    organisatieId: string | null;
    /** Gekoppelde product onderdelen */
    productonderdelen: string[] | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface NewOutput {
    id: string | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de output van het opvragen van HDN nodenummers. */
export interface HdnNodenummersOutput {
    /** Collectie met HDN nodenummers met bijbehorend ID */
    hdnNodenummers: { [key: string]: HdnNodenummer; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een HDN nodenummer. */
export interface HdnNodenummer {
    /** Nummer van de HDN node (kan voorloopnullen bevatten) */
    nodenummer: string;
    /** Indicatie dat het nodenummer geactiveerd is bij HDN */
    readonly geactiveerd: boolean | null;
    /** Geeft aan voor welke entiteit(en) het HDN nodenummer geldig is Vestiging = 1, Organisatie = 2 */
    geldigVoor: HdnNodenummerGeldigVoor | null;
    /** Vestigingen waarvoor het HDN nodenummer geldig is */
    vestigingen: HdnNodenummerVestiging[] | null;
}

/** Bevat gegevens van een vestiging waarvoor een HDN nodenummer geldig is. */
export interface HdnNodenummerVestiging {
    /** Het Id van de vestiging. */
    vestigingId: string | null;
    /** De naam van de vestiging */
    readonly naam: string | null;
}

/** Output van licentieovereenkomsten. */
export interface LicentieovereenkomstenOutput {
    /** Collectie met licentieovereenkomsten. */
    licentieovereenkomsten: { [key: string]: Licentieovereenkomst; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een licentieovereenkomst. */
export interface Licentieovereenkomst {
    /** Is de licentieovereenkomst geblokkeerd, buiten andere regels om (bv. bij wanbetaling) */
    isGeblokkeerd: boolean | null;
    /** Is de licentieovereenkomst actief */
    isActief: boolean | null;
    /** Begindatum van de overeenkomst */
    begindatum: string;
    /** Einddatum van de overeenkomst */
    einddatum: string | null;
    /** Datum van opzegging */
    opzegdatum: string | null;
    /** De opzegtermijn voor deze licentieovereenkomst */
    opzegtermijn: number | null;
    /** De licentiesoort van de licentieovereenkomst Betaald = 0, Proef = 1, Intern = 2 */
    licentiesoort: LicentieovereenkomstLicentiesoort | null;
    /** IBAN van de rekening */
    iban: string | null;
    /** E-mail adres */
    emailFinancieelGemachtigde: string | null;
    /** Betaalwijze Incasso = 0, Factuur = 1 */
    betaalwijze: LicentieovereenkomstBetaalwijze | null;
    /** ID van de gekoppelde organisatie */
    organisatieId: string | null;
    /** ID van het gekoppelde product */
    productId: string | null;
    /** Naam van het gekoppelde product */
    productNaam: string | null;
    /** Contractcode */
    contractId: string | null;
    /** Duur van de proefperiode in dagen */
    duurProefperiode: number | null;
    /** Eerste factuurdatum */
    eersteFactuurDatum: string | null;
    /** Ten behoeve van opslag T.a.v. */
    factuurNaamPersoon: string | null;
    /** Het adres waar de factuur naartoe gestuurd moet worden */
    factuurAdres: AdresInput | null;
    /** Kostenplaats van de factuur */
    kostenplaats: string | null;
    /** Vrije tekst op de factuur */
    vrijeTekst: string | null;
    /** Documenten behorende bij de overeenkomst */
    licentieovereenkomstDocumenten: { [key: string]: LicentieovereenkomstDocument; } | null;
}

/** De gegevens van een adres. */
export interface AdresInput {
    /** De straatnaam */
    straatnaam: string;
    /** Het huisnummer */
    huisnummer: string;
    /** Toevoeging op het huisnummer */
    toevoeging: string | null;
    /** De postcode */
    postcode: string;
    /** Land (identificatie) */
    landCode: string;
    /** Het land */
    land: string;
    /** De plaats */
    plaats: string;
}

/** Document behorende bij een licentieovereenkomst. */
export interface LicentieovereenkomstDocument {
    /** id van dit document */
    licentieovereenkomstDocumentId: string | null;
    /** De naam/titel van dit licentieovereenkomst document. */
    naam: string | null;
    /** De bestandsnaam. */
    bestandsnaam: string | null;
    /** Datum tijd van aanmaken document. */
    aanmaakDatumTijd: string | null;
    /** Naam van het bestand */
    url: string | null;
}

/** Gegevens van een licentie. */
export interface LicentiesOutput {
    /** Lijst met licenties en hun key */
    licenties: { [key: string]: Licentie; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een licentie. */
export interface Licentie {
    /** Unieke identificatie van de licentie binnen het platform. */
    platformId: string | null;
    /** ID van de gekoppelde medewerker */
    medewerkerId: string | null;
    /** ID van het gekoppelde productsamenstelling */
    productsamenstellingId: string | null;
    /** Naam van de productsamenstelling */
    productsamenstellingNaam: string | null;
    /** ID van de gekoppelde licentieovereenkomst */
    licentieovereenkomstId: string | null;
}

/** Uitvoer van een lijst met licentie gegevens van een productsamenstelling */
export interface LicentiesDetailsOutput {
    /** De lijst met lecentiegegevens van een productsamenstelling */
    productsamenstellingLicenties: { [key: string]: LicentiesDetails; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Licentie gegevens van een productsamenstelling */
export interface LicentiesDetails {
    /** Id van de licentie */
    licentieId: string | null;
    /** Id van de medewerker */
    medewerkerId: string | null;
    /** Gegevens van de medewerker */
    medewerker: Medewerker | null;
    /** Opsomming van de vestigingen die aan de medewerker gekoppeld zijn */
    vestiging: string | null;
    /** Einddatum van de licentie */
    einddatum: string | null;
}

/** Bevat gegevens van een medewerker. */
export interface Medewerker {
    /** Voornaam */
    voornaam: string | null;
    /** Tussenvoegsels */
    tussenvoegsels: string | null;
    /** Achternaam */
    achternaam: string;
    /** Roepnaam */
    roepnaam: string | null;
    /** Voorletters */
    voorletters: string;
    /** Geslacht Man = 0, Vrouw = 1, Neutraal = 2 */
    geslacht: MedewerkerGeslacht | null;
    /** Telefoonnummer */
    telefoon: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Mobiele nummer */
    telefoonMobiel: string | null;
    /** E-mail adres */
    email: string;
    /** Functie */
    functie: string | null;
    /** PlatformId */
    platformId: string | null;
    /** Klantcode */
    klantId: string | null;
    /** Actief */
    isActief: boolean | null;
    /** Rechten op de klantdossiers van de vestiging(en) waar de medewerker aan verbonden is Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
    klantdossierRechtenVestigingen: MedewerkerKlantdossierRechtenVestigingen | null;
    /** Rechten op de klantdossiers van de organisatie waar de medewerker aan verbonden is Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
    klantdossierRechtenOrganisatie: MedewerkerKlantdossierRechtenOrganisatie | null;
}

/** Output voor MedewerkerEx */
export interface MedewerkerExOutput {
    /** Unieke identificatie van een medewerker */
    medewerkers: { [key: string]: MedewerkerEx; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Medewerker met vestigingen */
export interface MedewerkerEx {
    /** Vestigingen */
    vestigingen: string[] | null;
    /** Gebruikersgroepen */
    gebruikersgroepen: string[] | null;
    /** Productsamenstelling van de licentie */
    productsamenstellingId: string | null;
    /** Naam van de productsamenstelling */
    productsamenstelling: string | null;
    /** Voornaam */
    voornaam: string | null;
    /** Tussenvoegsels */
    tussenvoegsels: string | null;
    /** Achternaam */
    achternaam: string;
    /** Roepnaam */
    roepnaam: string | null;
    /** Voorletters */
    voorletters: string;
    /** Geslacht Man = 0, Vrouw = 1, Neutraal = 2 */
    geslacht: MedewerkerExGeslacht | null;
    /** Telefoonnummer */
    telefoon: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Mobiele nummer */
    telefoonMobiel: string | null;
    /** E-mail adres */
    email: string;
    /** Functie */
    functie: string | null;
    /** PlatformId */
    platformId: string | null;
    /** Klantcode */
    klantId: string | null;
    /** Actief */
    isActief: boolean | null;
    /** Rechten op de klantdossiers van de vestiging(en) waar de medewerker aan verbonden is Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
    klantdossierRechtenVestigingen: MedewerkerExKlantdossierRechtenVestigingen | null;
    /** Rechten op de klantdossiers van de organisatie waar de medewerker aan verbonden is Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
    klantdossierRechtenOrganisatie: MedewerkerExKlantdossierRechtenOrganisatie | null;
}

/** Output voor Medewerker */
export interface MedewerkerOutput {
    /** Unieke identificatie van een medewerker */
    medewerkers: { [key: string]: Medewerker; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een medewerker en de organisatie waaraan de medewerker gekoppeld is. */
export interface MedewerkerOrganisatieOutput {
    /** Unieke identificatie van de medewerker. */
    medewerkerId: string | null;
    /** Gegevens van de medewerker. */
    medewerker: Medewerker | null;
    /** Unieke identificatie van de organisatie. */
    organisatieId: string | null;
    /** Naam van de organisatie. */
    readonly organisatieNaam: string | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De uitvoer van een opvraging van een lijst met vestigingen. */
export interface VestigingenOutput {
    /** De gevonden vestigingen */
    vestigingen: { [key: string]: Vestiging; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van de vestiging. */
export interface Vestiging {
    /** De naam van de vestiging */
    naam: string;
    /** Het bezoekadres van de vestiging */
    bezoekadres: AdresInput;
    /** Het postadres van de vestiging */
    postadres: AdresInput | null;
    /** Het e-mailadres van (de contactpersoon van) de vestiging */
    emailadres: string;
    /** Het telefoonnummer van de vestiging */
    telefoonnummer: string;
    /** Unieke identificatie van de vestiging binnen het platform */
    platformId: string | null;
    /** Het AFM-registratienummer */
    afmRegistratienummer: string;
    /** Geeft aan of dit de hoofdvestiging is */
    isHoofdvestiging: boolean | null;
    /** Geeft bijbehorende organisatieId aan */
    organisatieId: string | null;
}

/** Het resultaat van een de vraag of een e-mailadres in gebruik is. */
export interface EmailInGebruikOutput {
    /** Indicatie dat het e-mailadres in gebruik is bij een medewerker. */
    inGebruik: boolean | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor het opvragen van rechten van een medewerker. */
export interface RechtenOutPut {
    /** De rechten van een medewerker */
    rechten: string[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de output van het opvragen van (extended) organisaties. */
export interface OrganisatiesExOutput {
    /** Lijst met organisaties en hun key */
    organisaties: { [key: string]: OrganisatieEx; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Organisatie en vestiging voor het toevoegen van een nieuwe organisatie (met hoofdvestiging). */
export interface OrganisatieEx {
    /** Vestiging */
    vestiging: Vestiging | null;
    /** Licentieovereenkomsten */
    licentieovereenkomsten: Licentieovereenkomst[] | null;
    /** Naam van de organisatie */
    naam: string;
    /** Unieke identificatie van de organisatie binnen het platform */
    platformId: string | null;
    /** Het KvK-nummer van de organisatie */
    kvKnummer: string | null;
    /** Logo van de organisatie */
    logo: string | null;
    /** IBAN voor incasso */
    iban: string | null;
    /** Het Id van de organisatie. */
    organisatieId: string | null;
}

/** Bevat de output van het opvragen van organisaties. */
export interface OrganisatiesOutput {
    /** Lijst met organisaties en hun key */
    organisaties: { [key: string]: Organisatie; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een organisatie. */
export interface Organisatie {
    /** Naam van de organisatie */
    naam: string;
    /** Unieke identificatie van de organisatie binnen het platform */
    platformId: string | null;
    /** Het KvK-nummer van de organisatie */
    kvKnummer: string | null;
    /** Logo van de organisatie */
    logo: string | null;
    /** IBAN voor incasso */
    iban: string | null;
    /** Het Id van de organisatie. */
    organisatieId: string | null;
}

/** Het resultaat van een de vraag of een KvK-nummer in gebruik is. */
export interface KvKnummerInGebruikOutput {
    /** Indicatie dat het KvK-nummer in gebruik is bij een organisatie met een actieve licentieovereenkomst */
    inGebruik: boolean | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Het resultaat van een zoekopdracht */
export interface ZoekresultaatOutput {
    /** De zoekresultaten */
    readonly zoekresultaten: Zoekresultaat[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Een zoekresultaat */
export interface Zoekresultaat {
    /** De gegevens van de gevonden organisatie */
    readonly organisatie: Organisatie | null;
    /** De hoofdvestiging van de organisatie */
    readonly hoofdvestiging: Vestiging | null;
}

/** Gegevens van een product. */
export interface Product {
    /** Naam van het product */
    naam: string;
    /** Code van het product */
    code: string;
    /** Unieke identificatie van het product binnen het platform */
    platformId: string | null;
    /** Status (Actief, Niet actief) */
    isActief: boolean | null;
    /** Indien 'false' mag het product niet getoond worden in het aanbod waar de gebruiker zelf zijn licentie kan bestellen */
    isOnlineBestelbaar: boolean | null;
}

/** Producten output. */
export interface ProductenOutput {
    /** Lijst met producten en hun key */
    producten: { [key: string]: Product; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Onderdeel van een product. */
export interface Productonderdeel {
    /** Naam van het productonderdeel. */
    naam: string;
    /** Code van het productonderdeel */
    code: string | null;
    /** Geeft aan of het productonderdeel actief is. */
    isActief: boolean | null;
    /** Geeft aan of het productonderdeel instelbaar is door de klant. */
    isInstelbaarDoorKlant: boolean | null;
    /** ID van het gekoppelde product */
    productId: string | null;
    /** Aantal gekoppelde gebruikersgroepen */
    aantalGekoppeldeGebruikersgroepen: number | null;
}

/** Uitvoer van een lijst met productonderdelen. */
export interface ProductonderdelenOutput {
    /** De lijst met productonderdelen */
    productOnderdelen: { [key: string]: Productonderdeel; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Complete gegevens van een productsamenstelling. */
export interface Productsamenstelling {
    /** Naam van de product samenstelling */
    naam: string | null;
    /** Code van de product samenstelling */
    code: string | null;
    /** Gekoppeld product */
    productId: string | null;
    /** Gekoppelde product onderdelen */
    productonderdelen: string[] | null;
    /** Aantal gekoppelde licenties */
    aantalGekoppeldeLicenties: number | null;
    /** Is de productsamenstelling actief? */
    isActief: boolean | null;
}

/** Uitvoer van een lijst met productsamenstellingen. */
export interface ProductsamenstellingenOutput {
    /** De lijst met productonderdelen. */
    productSamenstellingen: { [key: string]: Productsamenstelling; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Uitvoermodel van registratie kantoor. */
export interface RegistratieKantoorOutput {
    /** De gegevens van het registratiescherm. */
    registratieKantoor: RegistratieKantoor | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De gegevens van het registratiescherm. */
export interface RegistratieKantoor {
    /** Gegevens van het schermonderdeel kantoor. */
    kantoorgegevens: Kantoorgegevens;
    /** Gegevens van het schermonderdeel contactpersoon. */
    contactpersoon: Contactpersoon;
    facturatieGegevens: FacturatieGegevens | null;
    /** Captcha response van de client */
    captchaToken: string | null;
}

/** Ggevens betreffende een kantoor */
export interface Kantoorgegevens {
    /** Naam Bedrijf. */
    bedrijfsnaam: string;
    /** KVK nummer. */
    kvkNummer: string;
    /** AFM Nummer. */
    afmVergunningsnummer: string | null;
    /** De postcode. */
    postcode: string;
    /** Het huisnummer. */
    huisnummer: string;
    /** Toevoeging op het huisnummer. */
    toevoeging: string | null;
    /** De straatnaam. */
    straat: string;
    /** De plaats. */
    plaats: string;
    /** Telefoonnummer. */
    algemeenTelefoonnummer: string;
    /** Bank (IBAN) rekening voor incasso. */
    ibanVoorIncasso: string;
}

/** Gegevens contactpersoon voor een kantoor */
export interface Contactpersoon {
    /** Voornaam. */
    voornaam: string | null;
    /** Voorletters. */
    voorletters: string;
    /** Tussenvoegsel. */
    tussenvoegsel: string | null;
    /** Achternaam. */
    achternaam: string;
    /** Geslacht Man = 0, Vrouw = 1, Neutraal = 2 */
    geslacht: ContactpersoonGeslacht | null;
    /** E-mail adres. */
    emailadres: string;
    /** E-mail adres bevestiging. */
    emailadresBevestiging: string;
    /** Telefoonnummer. */
    telefoonnummer: string;
}

/** Adres voor factuur */
export interface FacturatieGegevens {
    terAttentieVan: string | null;
    straat: string | null;
    huisnummer: string | null;
    toevoeging: string | null;
    postcode: string | null;
    plaats: string | null;
}

/** Overeenkomst */
export interface Overeenkomst {
    /** Id van de overeenkomst */
    overeenkomstId: string;
    /** Gets/sets OvereenkomstAkkoord. */
    overeenkomstAkkoord: boolean | null;
}

/** Bevat gegevens van een Subscription op de Service Bus Topic waarmee de trigger voor een Overeenkomst kan worden verkregen. */
export interface RegistreerkantoorSubscriptionOutput {
    /** Unieke ID van de overeenkomst (= naam van Topic Subscription) */
    readonly organisatieId: string | null;
    /** SAS-token waarmee lees-rechten voor de Topic Subscription verkregen worden */
    readonly sasToken: string | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een Subscription op de Service Bus Topic waarmee de trigger voor een Overeenkomst kan worden verkregen. */
export interface OvereenkomstSubscriptionOutput {
    /** De gegevens van subscription overzicht */
    subscription: OvereenkomstSubscription | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een Subscription op de Service Bus Topic waarmee de trigger voor een Overeenkomst kan worden verkregen. */
export interface OvereenkomstSubscription {
    /** Unieke ID van de overeenkomst (= naam van Topic Subscription) */
    readonly overeenkomstId: string | null;
    /** SAS-token waarmee lees-rechten voor de Topic Subscription verkregen worden */
    readonly sasToken: string | null;
}

/** Bevat de inhoud van het registratie-form. */
export interface Registreren {
    /** Gegevens van de organisatie */
    organisatie: Organisatie | null;
    /** Gegevens van de vestiging */
    vestiging: Vestiging | null;
    /** Gegevens van de medewerker */
    medewerker: Medewerker | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface BadRequestResult {
    readonly statusCode: number | null;
}

/** Criterium waarop gezocht wordt Organisatienaam = 0, Postcode = 1, Plaats = 2, KvkNummer = 3 */
export enum Soort {
    Organisatienaam = "Organisatienaam",
    Postcode = "Postcode",
    Plaats = "Plaats",
    KvkNummer = "KvkNummer",
}

export enum HdnNodenummerGeldigVoor {
    Vestiging = "Vestiging",
    Organisatie = "Organisatie",
}

export enum LicentieovereenkomstLicentiesoort {
    Betaald = "Betaald",
    Proef = "Proef",
    Intern = "Intern",
}

export enum LicentieovereenkomstBetaalwijze {
    Incasso = "Incasso",
    Factuur = "Factuur",
}

export enum MedewerkerGeslacht {
    Man = "Man",
    Vrouw = "Vrouw",
    Neutraal = "Neutraal",
}

export enum MedewerkerKlantdossierRechtenVestigingen {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

export enum MedewerkerKlantdossierRechtenOrganisatie {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

export enum MedewerkerExGeslacht {
    Man = "Man",
    Vrouw = "Vrouw",
    Neutraal = "Neutraal",
}

export enum MedewerkerExKlantdossierRechtenVestigingen {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

export enum MedewerkerExKlantdossierRechtenOrganisatie {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

export enum ContactpersoonGeslacht {
    Man = "Man",
    Vrouw = "Vrouw",
    Neutraal = "Neutraal",
}